export default "__VITE_ASSET__D0XzSV6V__"